import React from 'react'
import '../styles/hero.css'
import { Trophy, Users, Zap, ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom';

function TournamentsHeroSection() {
  return (
    <div className="tournaments-hero-section">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <div className="hero-particles"></div>
      </div>
      
      <div className="tournament-hero-content">
        <div className="hero-left">
          <div className="tournament-hero-badge">
            <Trophy className="badge-icon" size={20} />
            <span>LIVE TOURNAMENTS</span>
          </div>
          
          <h1 className="hero-title">
            <span className="title-line-1">COMPETE</span>
            <span className="title-line-2">DOMINATE</span>
            <span className="title-line-3">CONQUER</span>
          </h1>
          
          <p className="hero-subtitle">
            Join the ultimate gaming arena where legends are born. 
            Compete with the best players across Africa and claim your victory.
          </p>
          
          <div className="hero-stats">
            <div className="stat-item">
              <Users className="stat-icon" size={24} />
              <div className="stat-content">
                <span className="stat-number">1.5K+</span>
                <span className="stat-label">Active Players</span>
              </div>
            </div>
            <div className="stat-item">
              <Trophy className="stat-icon" size={24} />
              <div className="stat-content">
                <span className="stat-number">500+</span>
                <span className="stat-label">Tournaments</span>
              </div>
            </div>
            <div className="stat-item">
              <Zap className="stat-icon" size={24} />
              <div className="stat-content">
                <span className="stat-number">$10K+</span>
                <span className="stat-label">Prize Pool</span>
              </div>
            </div>
          </div>
          
          <div className="hero-actions">
            <a href="#join-tournaments-section" className="hero-btn primary">
              <span>Join Tournament</span>
              <ArrowRight className="btn-icon" size={20} />
            </a>
            <Link to="/games" className="hero-btn secondary">
              <span>Browse Games</span>
            </Link>
          </div>
        </div>
        
        <div className="hero-right">
          <div className="hero-visual">
            <div className="floating-card card-1">
              <div className="card-glow"></div>
              <div className="card-content">
                <div className="card-game">Call of Duty</div>
                <div className="card-prize">$500 Prize</div>
              </div>
            </div>
            <div className="floating-card card-2">
              <div className="card-glow"></div>
              <div className="card-content">
                <div className="card-game">FIFA 23</div>
                <div className="card-prize">$300 Prize</div>
              </div>
            </div>
            <div className="floating-card card-3">
              <div className="card-glow"></div>
              <div className="card-content">
                <div className="card-game">NBA 2K</div>
                <div className="card-prize">$400 Prize</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TournamentsHeroSection
